import { createAction, props } from '@ngrx/store';

import { ICallableParaTi, IResultParati } from '../../shared/models/ParaTi.model';

/**
 * Obtiene las notificaciones del usuario
 */
export const getParaTi = createAction(
    '[GetParaTi] Get ParaTi',
    props<ICallableParaTi>()
);

export const successParaTi = createAction(
    '[GetParaTi] Get ParaTi Success',
    props<IResultParati>()
);

export const errorParaTi = createAction(
    '[GetParaTi] Get ParaTi Error',
    props<{ payload: Error }>()
);
